module.exports = __webpack_public_path__ + "img/american_credit_prequalify_promptly.83d4e6d.jpg";